import React from "react";
import ReactDOM from "react-dom/client";
import Ruteo from "./Ruteo/direcciones";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Ruteo />
  </React.StrictMode>
);